import { Button } from '@chakra-ui/react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PropTypes from 'prop-types';
import React from 'react';
import heartLikeAnimation from '../../Assets/Animations/heartLikeAnimation.lottie';
import { status } from '../../Services';
import { isTabletOrLowerOnResize } from '../../Services/Window/Viewport';

export function FavoriteButton({ plot, projectName, hasOffsetRight }) {
  const dotLottieRef = React.useRef(null);
  const isMobile = isTabletOrLowerOnResize();
  const offsetRight = isMobile ? '2.6rem' : '2.4rem';

  return (
    <Button
      position="absolute"
      right={hasOffsetRight ? offsetRight : '0'}
      width={isMobile ? '2.5rem' : '2.3rem'}
      height={isMobile ? '2.5rem' : '2.3rem'}
      backgroundColor="#E7EDF9"
      borderRadius="50%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <DotLottieReact
        style={{
          marginRight: '0.5px', // Center correction
          width: '2rem',
          height: '2rem',
        }}
        src={`${heartLikeAnimation}`}
        onClick={() => {
          dotLottieRef.current?.stop();
          dotLottieRef.current?.play();
          sendDataBeyondIframe();
        }}
        dotLottieRefCallback={(dotLottie) => {
          dotLottieRef.current = dotLottie;
        }}
      />
    </Button>
  );

  function sendDataBeyondIframe() {
    const data = {
      type: 'FAVORITE_PLOT',
      payload: {
        id: plot.id,
        uuid: plot.uuid,
        project_id: plot.salesforce_project_uuid,
        number: plot.number,
        status: status(plot.status, true),
        from_price: plot.from_price,
        to_price: plot.to_price,
        type: plot.type,
        price: plot.price,
        is_indicative_price: plot.is_indicative_price,
        image: plot.media?.[0]?.url || '',
        living_surface: plot.living_surface || 0,
        project_name: projectName || '',
      },
    };

    window.parent.postMessage(data, '*');
  }
}

FavoriteButton.propTypes = {
  plot: PropTypes.object.isRequired,
  projectName: PropTypes.string,
  hasOffsetRight: PropTypes.bool,
};
